import { env } from "env";

export function hasLeadingSlash(path: string) {
	return path.startsWith("/");
}

export function appLink(path: string) {
	return `${env.NEXT_PUBLIC_APP_URL}${hasLeadingSlash(path) ? path : `/${path}`}`;
}
